import { render, staticRenderFns } from "./PreviewReply.vue?vue&type=template&id=fdd85132&scoped=true&"
import script from "./PreviewReply.vue?vue&type=script&lang=js&"
export * from "./PreviewReply.vue?vue&type=script&lang=js&"
import style0 from "./PreviewReply.vue?vue&type=style&index=0&id=fdd85132&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd85132",
  null
  
)

export default component.exports